// Segmented tab control — used by RunDetailPage.
// Tabs prop accepts either:
//   - a string                                 → enabled tab
//   - { label, disabled?: boolean, title?: string } → optionally disabled with tooltip
export default function SegmentedTabs({ tabs, value, onChange, testIdPrefix = "tab" }) {
    const items = tabs.map((t) =>
        typeof t === "string" ? { label: t, disabled: false, title: undefined } : t,
    );
    return (
        <div
            role="tablist"
            className="inline-flex items-center bg-ux-bg-1 border border-ux-border-1 rounded-md p-0.5"
        >
            {items.map((t) => {
                const active = t.label === value;
                return (
                    <button
                        key={t.label}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        aria-disabled={t.disabled || undefined}
                        title={t.title || undefined}
                        disabled={t.disabled}
                        onClick={() => !t.disabled && onChange(t.label)}
                        data-testid={`${testIdPrefix}-${t.label.toLowerCase()}`}
                        className={[
                            "px-3 h-8 text-[13px] rounded-[5px] transition-colors",
                            t.disabled
                                ? "text-ux-text-3 cursor-not-allowed opacity-60"
                                : active
                                    ? "bg-ux-bg-3 text-ux-text-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]"
                                    : "text-ux-text-2 hover:text-ux-text-1",
                        ].join(" ")}
                    >
                        {t.label}
                    </button>
                );
            })}
        </div>
    );
}
